<template>
  <div id="mapContainer" class="mapContainer">
    <div id="scrapSubsidyMap" class="map"></div>
  </div>
</template>

<script>
import * as purchaseAllowanceApi from "@/api/governmentAffairs/purchaseAllowance.js";
import { getMapSeting } from "@/api/ai.js";
import Vue from "vue";
import { fromLonLat } from "ol/proj";
import Map from "ol/Map";
import Feature from "ol/Feature";
import Overlay from "ol/Overlay";
import Point from "ol/geom/Point";
import Cluster from "ol/source/Cluster";
import { Tile as TileLayer } from "ol/layer";
import { DoubleClickZoom, DragPan, MouseWheelZoom } from "ol/interaction";
import VectorSource from "ol/source/Vector";
import { Vector as VectorLayer } from "ol/layer";
import { XYZ } from "ol/source";
import View from "ol/View";
// import GeoJSON from "ol/format/GeoJSON.js";
// import GIS_MAP from "@/assets/JSON/gisMap";
import { TileSuperMapRest } from "@supermap/iclient-ol";
import { defaults as defaultControls } from "ol/control";
import { Style, Icon, Stroke, Circle, Fill, Text } from "ol/style";
import infoWindow from "./InfoWindow";

export default {
  props: {
    areaList: {
      type: Object,
      default: {},
    },
    rectBounds: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      // 地图对象
      map: null,
      // 特效图
      imgLayer: null,
      // 是否是省级单位
      isProvinceLevel: true,
      //使用率、兑付率弹窗
      infoWindow: infoWindow,
      winCotent: null,
      winInfo: null,
      layers: {
        baseLayer: null,
      },
      // 地域名称矢量图层
      areaVectorLayer: null,
      // 地图报废图标选中对象
      currentPoint: null,
      // 地图中心点
      centerCoordinate: [113.46, 33.4],
      mapSeting: null,
    };
  },
  mounted() {
    this.initMap();
  },
  watch: {
    areaList: {
      deep: true,
      handler(newVal, oldVal) {
        this.$nextTick(() => {
          this.addAreaNameAndIcon();
        });
      },
    },
  },
  computed: {},
  methods: {
    /**
     * @description: 切换图层
     * @cityCode {String} 城市编码
     * @return {void}
     */
    async addProvince(city = "410000000") {
      let _this = this;
      let params = {
        areaCode: city,
        largeScreenType: "scrapSubsidy",
      };
      this.mapSeting = await getMapSeting(params);
      // if (!GIS_MAP[city]) {
      if (!this.mapSeting || !this.mapSeting.specialEffectsUrl) {
        console.log("失败 :>> ", "未找到区域图层");
        this.map.removeLayer(this.layers.baseLayer);
        return;
      } else {
        this.map.getView().setZoom(this.mapSeting.zoom);
        this.map.getView().setCenter(this.mapSeting.center.split(","));
        // this.map.getView().setZoom(GIS_MAP[city].scrapSubsidyZoom);
        // this.map.getView().setCenter(GIS_MAP[city].scrapSubsidyCenter);
        this.map.removeLayer(this.layers.baseLayer);
        this.map.removeLayer(this.imgLayer);
        this.map.getOverlays().clear();
        this.areaVectorLayer.getSource().clear();
        this.imgLayer = new TileLayer({
          source: new TileSuperMapRest({
            // url: _this.$utils.formatUrl(GIS_MAP[city].scrapSubsidyUrl),
            url: _this.$utils.formatUrl(_this.mapSeting.specialEffectsUrl),
            cacheEnabled: true,
          }),
          zindex: 2,
          isGroup: true,
          name: "高清影像图",
        });
        this.map.addLayer(this.imgLayer);
        // this.addAreaNameAndIcon();
      }
    },
    // 添加区域名称图标、icon图标
    addAreaNameAndIcon() {
      this.map.getOverlays().clear();
      if (this.currentPoint) {
        if (this.currentPoint.overlay) {
          this.map.removeOverlay(this.currentPoint.overlay);
          this.currentPoint.overlay = null;
        }
        this.currentPoint = null;
      }
      purchaseAllowanceApi
        .getAreaLonAndLat(this.$store.state.activeRegionObj.areaCode)
        .then((res) => {
          let lonAndLatList = res || [];
          let allImages = require.context(
            "@/assets/images/governmentAffairs/scrapSubsidy/map/",
            false,
            /\.png$/
          );
          // 生成区域名称图标
          for (let j = 0; j < lonAndLatList.length; j++) {
            lonAndLatList[j].detail =
              this.areaList[lonAndLatList[j].areaId] || [];
            // if(lonAndLatList[j].areaId == '419000000') {
            //   lonAndLatList[j].areaName = '济源市';
            // }
            let areaNameFeature = new Feature({
              geometry: new Point([
                lonAndLatList[j].longitude,
                lonAndLatList[j].latitude,
              ]),
              name: "区域名",
            });
            if (
              allImages.keys().includes(`./${lonAndLatList[j].areaName}.png`)
            ) {
              areaNameFeature.setStyle(
                new Style({
                  image: new Icon({
                    // src: allImages[`./${lonAndLatList[j].areaName}.png`],
                    src: require(`@/assets/images/governmentAffairs/scrapSubsidy/map/${lonAndLatList[j].areaName}.png`),
                    scale: 1,
                    anchor: [0.5, 1],
                    displacement: [0, 0],
                  }),
                })
              );
              this.areaVectorLayer.getSource().addFeature(areaNameFeature);
              // 报废图标
              let overlay = this.creatOverlay(
                lonAndLatList[j],
                "scrap-map-icon"
              );
              this.map.addOverlay(overlay);
            } else {
              continue;
            }
            // if(require(`@/assets/images/governmentAffairs/scrapSubsidy/map/${lonAndLatList[j].areaName}.png`)) {
            //   areaNameFeature.setStyle(
            //     new Style({
            //       image: new Icon({
            //         src: require(`@/assets/images/governmentAffairs/scrapSubsidy/map/${lonAndLatList[j].areaName}.png`),
            //         scale: 1,
            //         anchor: [0.5, 1],
            //         displacement: [0, 0]
            //       }),
            //     })
            //   )
            // }
          }
          this.map.addLayer(this.areaVectorLayer);
        });
    },
    // 创建报废图标
    creatOverlay(itemInfo, className) {
      if (itemInfo.overlay) {
        this.map.removeOverlay(itemInfo.overlay);
        itemInfo.overlay = null;
      }
      let element = document.createElement("div");
      element.className = "scrap-map-box";
      element.innerHTML = `
        <div class="scrap-map-value">${itemInfo.detail.length}</div>
        <div class="${className}"></div>
      `;
      let overlay = new Overlay({
        element: element,
        position: [itemInfo.lon, itemInfo.lat],
        // offset: [-80, 0],
        positioning: "center-center",
        stopEvent: false,
      });
      // overlay.set('_key', );
      itemInfo.overlay = overlay;
      let dataItem = itemInfo;
      overlay.getElement().addEventListener("click", (event) => {
        this.choseAndOpenItem(dataItem, [dataItem.lon, dataItem.lat]);
      });
      return overlay;
    },
    // 重叠检测函数
    checkOverlap(popupLeft, popupTop, popupWidth, popupHeight, rect) {
      const popupRight = popupLeft + popupWidth;
      const popupBottom = popupTop + popupHeight;

      return (
        popupRight > rect.right ||
        popupLeft < rect.left ||
        popupBottom < rect.bottom ||
        popupTop > rect.top
      );
    },
    adjustPopupPosition(overlay, pixel, width, height, rect) {
      const mapSize = this.map.getSize();
      let positioning = "center-left";
      let horizontal = "right";
      let vertical = "center";

      // 检测右侧是否有空间
      if (pixel[0] + width > rect.right) {
        horizontal = "right";
      }
      if (pixel[0] - width < rect.left) {
        horizontal = "left";
      }
      // 检测上方是否有空间
      if (pixel[1] + height < rect.bottom) {
        vertical = "top";
      }
      if (pixel[1] - height > rect.top) {
        vertical = "bottom";
      }
      positioning = vertical + "-" + horizontal;
      overlay.setPositioning(positioning);
      overlay.setOffset([horizontal === "right" ? -18 : 18, 10]);
      // overlay.setOffset([positioning === 'center-left' ? -width : 10, 10]);
    },
    // 选中地图上报废图标、并显示弹窗
    choseAndOpenItem(dataItem, lonAndLat) {
      // console.log('choseAndOpenItem.dataItem::', dataItem, ',lonAndLat::', lonAndLat);
      // dataItem.detail = [
      //   {
      //     recyclingCompanyName: '漯河蓝众再生资源有限公司',
      //     socialCreditCode: '91411100MA9FXJ1U0R',
      //     legalRepresentativeName: '张永超',
      //     businessLocation: '漯河市召陵区龙江路林庄村路口东350米路北',
      //     recyclingStandards:
      //   },
      // ]
      // this.map.getOverlays().clear();
      if (dataItem.overlay) {
        this.map.removeOverlay(dataItem.overlay);
        dataItem.overlay = null;
      }
      // 先把上次overlay重置为未选中
      if (this.currentPoint) {
        this.resetOvery(this.currentPoint);
      }
      // 重新设置选中对象
      this.currentPoint = dataItem;
      let overlay = this.creatOverlay(
        this.currentPoint,
        "scrap-map-icon-chosed"
      );
      this.map.addOverlay(overlay);
      // 打开弹窗
      if (this.winCotent) {
        if (this.winCotent.$el.parentNode) {
          this.winCotent.$el.parentNode.removeChild(this.winCotent.$el);
        }
      }
      if (dataItem.detail.length == 0) {
        return false;
      }
      const Content = Vue.extend(infoWindow);
      this.winCotent = new Content({
        propsData: {
          vmm: this,
          infoObj: { ...dataItem },
        },
      }).$mount();
      if (this.winInfo) {
        this.map.removeOverlay(this.winInfo);
        this.winInfo = null;
      }
      let pixel = this.map.getPixelFromCoordinate(lonAndLat); // 地理坐标转像素坐标
      let positioning = "center-left";
      let offset = [18, 0];
      // if(lonAndLat[0] > this.centerCoordinate[0]) {
      //   positioning = 'center-right';
      //   offset = [-18, 0];
      // }
      // if(lonAndLat[0] > this.centerCoordinate[0] && lonAndLat[1] > this.centerCoordinate[1]) {
      //   positioning = 'top-right';
      //   offset = [-18, -100];
      // }
      // if(lonAndLat[0] > this.centerCoordinate[0] && lonAndLat[1] < this.centerCoordinate[1]) {
      //   positioning = 'center-right';
      //   offset = [-18, -20];
      // }
      // 调整弹窗左右位置时，到时候再看
      this.winInfo = new Overlay({
        element: this.winCotent.$el,
        positioning: positioning,
        offset: offset,
        insertFirst: true,
        stopEvent: false,
      });
      this.winInfo.getElement().parentNode.style.zIndex = 100;
      this.map.addOverlay(this.winInfo);
      this.winInfo.setPosition(lonAndLat);
      let popupElement = this.winInfo.getElement();
      let popupWidth = popupElement.offsetWidth;
      let popupHeight = popupElement.offsetHeight;
      let popupLeft = pixel[0] + this.winInfo.values_.offset[0];
      let popupTop = pixel[1] + this.winInfo.values_.offset[1];
      // 检测是否与四周矩形重叠
      let isOverlap = this.checkOverlap(
        popupLeft,
        popupTop,
        popupWidth,
        popupHeight,
        this.rectBounds
      );
      if (isOverlap) {
        this.adjustPopupPosition(
          this.winInfo,
          pixel,
          popupWidth,
          popupHeight,
          this.rectBounds
        );
      } else {
        this.winInfo.setPosition(lonAndLat);
      }

      // this.map.getView().animate({
      //   center: lonAndLat,
      //   duration: 800,
      // });
    },
    closeWindow() {
      if (this.winInfo) {
        this.map.removeOverlay(this.winInfo);
        this.winInfo = null;
      }
      // 先把上次overlay重置为未选中
      if (this.currentPoint) {
        this.resetOvery(this.currentPoint);
      }
    },
    // 恢复默认状态
    resetOvery(currentPoint) {
      if (currentPoint.overlay) {
        this.map.removeOverlay(currentPoint.overlay);
        currentPoint.overlay = null;
        let overlay = this.creatOverlay(currentPoint, "scrap-map-icon");
        this.map.addOverlay(overlay);
      }
    },
    initMap() {
      let that = this;
      // 创建地域名称矢量图层
      this.areaVectorLayer = new VectorLayer({
        source: new VectorSource(),
        zIndex: 3,
      });
      this.map = new Map({
        target: "scrapSubsidyMap",
        layers: [],
        controls: defaultControls({
          attribution: false,
        }),
        view: new View({
          center: this.centerCoordinate,
          zoom: 7.6,
          projection: "EPSG:4326",
          maxZoom: 14,
          minZoom: 3.5,
        }),
      });
      this.map.on("singleclick", (e) => {
        this.closeWindow();
      });
      // this.addAreaNameAndIcon();
      // 禁用拖动
      this.map.getInteractions().forEach(function (interaction) {
        if (interaction instanceof DragPan) {
          interaction.setActive(false);
        }
      });
      // 禁用双击缩放
      this.map.getInteractions().forEach(function (interaction) {
        if (interaction instanceof DoubleClickZoom) {
          interaction.setActive(false);
        }
      });
      // 禁用滚轮缩放
      this.map.getInteractions().forEach(function (interaction) {
        if (interaction instanceof MouseWheelZoom) {
          interaction.setActive(false);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 1920) * 100vw;
}
@function vh($px) {
  @return ($px / 1080) * 100vh;
}
.mapContainer {
  float: right;
  width: 100%;
  height: 100%;
  position: relative;
  ::v-deep {
    .ol-attribution.ol-unselectable.ol-control.ol-collapsed {
      display: none;
    }
    .ol-control {
      display: none;
    }
  }
}
.ol-zoom.ol-unselectable.ol-control {
  display: none;
}
.map {
  width: 100%;
  height: 100%;
}
.ol-rotate {
  display: none;
}
</style>
